import {
  DaysType,
  DetailedPublicationSchema,
  PublishingRuleRetrieveSchema,
} from "./types";

export const formatDays = (schedule: PublishingRuleRetrieveSchema) => {
  const days = [
    schedule.monday && "Måndag",
    schedule.tuesday && "Tisdag",
    schedule.wednesday && "Onsdag",
    schedule.thursday && "Torsdag",
    schedule.friday && "Fredag",
    schedule.saturday && "Lördag",
    schedule.sunday && "Söndag",
  ].filter(Boolean);

  if (days.length === 0) return "";
  if (days.length === 1) return days[0];

  return days.join(", ");
};

export const daysType: Record<DaysType, string> = {
  business_days: "vardagar",
  any_days: "alla dagar",
};

export const formatDaysType = (dt: DaysType) => {
  return daysType[dt];
};

export const formatTime = (hour: number, minute: number) => {
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

export const GAP = 2;
export const GRID_FOUR_COLUMNS = "repeat(4, 1fr)";

export const toTitleCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatScheduleName = (
  schedule: PublishingRuleRetrieveSchema,
  locale = "sv-SE",
) => {
  const weekdays = Array.from({ length: 7 }, (_, i) =>
    new Intl.DateTimeFormat(locale, { weekday: "short" })
      .format(new Date(Date.UTC(2024, 0, i + 1)))
      .toLowerCase(),
  );

  const scheduleDays: boolean[] = [
    schedule.monday,
    schedule.tuesday,
    schedule.wednesday,
    schedule.thursday,
    schedule.friday,
    schedule.saturday,
    schedule.sunday,
  ];

  const selectedDays = weekdays.filter((_, i) => scheduleDays[i]);
  if (selectedDays.length === 0) return "0 dagar";

  const ranges: string[] = [];
  let currentRange: string[] = [];

  for (const day of selectedDays) {
    const nextDay = selectedDays[selectedDays.indexOf(day) + 1];

    currentRange.push(day);

    if (!nextDay || weekdays.indexOf(nextDay) !== weekdays.indexOf(day) + 1) {
      ranges.push(
        currentRange.length > 1
          ? `${currentRange[0]}-${currentRange[currentRange.length - 1]}`
          : (currentRange[0] ?? ""),
      );
      currentRange = [];
    }
  }

  return `${selectedDays.length} dagar: ${ranges.join(", ")}`;
};

export const formatPublicationRuleName = (
  rule: DetailedPublicationSchema["current_rule"],
) => {
  if (!rule) return "—";

  const leadTime = `${rule.publication_lead_time} helgfria ${daysType[rule.days_type]}`;
  const time = formatTime(rule.hour, rule.minute);

  return `${leadTime}, ${time}`;
};
